async function handleLogout(logout: () => void) {
  await logout()
  window.localStorage.clear()
  window.location.reload()
}

export default handleLogout
